<template>
  <div id="person-web-container">
    <iframe
      :src="iframeSrc"
      frameborder="0"
      style="width: 100vw; height: 100vh; border: none;"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'PersonWebProxy',
  computed: {
    iframeSrc() {
      const path = this.$route.fullPath || this.$route.path;
      const queryIndex = path.indexOf('?');
      const pageSearch = queryIndex >= 0 ? path.substring(queryIndex) : '';
      return `/person-web/index.html${pageSearch}#${path}`;
    }
  }
}
</script>
